import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import PaymentProcessModal from "../../components/modals/PaymentProcessModal";
import { ArrowLeftIcon2, BusIcon, ArrowRightIcon } from "assets/icons";
import { getBusLayout } from "../../redux/axios";
import {
  setTicketActiveStep,
  setOpenTicketDetail,
  setOpenPaymentProcessModal,
} from "../../redux/reducers/bookingReducer";
import Step1 from "./step1";
import Step2 from "./step2";

function TicketBooking() {
  const dispatch = useDispatch();
  const {
    ticketActiveStep,
    openTicketDetail,
    busDetail,
    openPaymentProcessingModal,
  } = useSelector((state) => state.bookingReducer);
  const [loading, setLoading] = useState(false);
  const [busLayout, setBusLayout] = useState(null);

  useEffect(() => {
    if (busDetail) {
      fetchBusLayout();
    }
  }, [busDetail]);

  const fetchBusLayout = async () => {
    let params = {
      bus_id: busDetail.bus_id,
      trip_date: moment(busDetail.trip_date).format("YYYY-MM-DD"),
      uid: 1,
    };
    let res = await getBusLayout(params, setLoading);
    if (res?.BusLayoutData?.length > 0) setBusLayout(res.BusLayoutData[0]);
  };

  const handleBack = () => {
    if (ticketActiveStep === 1) {
      dispatch(setOpenTicketDetail(false));
    } else if (ticketActiveStep === 2) {
      dispatch(setTicketActiveStep(1));
    }
  };

  return (
    <>
      <div
        className={`fixed inset-0 bg-black/25 z-[1000] justify-end ${
          openTicketDetail ? "flex" : "hidden"
        }`}
      >
        <div
          className={`w-full h-screen lg:max-w-[650px] bg-foreground-700 ${
            openTicketDetail ? "slide-in" : ""
          }`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex items-start bg-primary-700 py-4 px-3 md:px-6">
            <button
              onClick={handleBack}
              className="text-white h-4 w-4 mr-3 md:mr-16"
            >
              <ArrowLeftIcon2 />
            </button>
            <div className="flex-1 flex gap-3 sm:gap-6">
              <div className="text-white">
                <BusIcon />
              </div>
              <div className="flex flex-col gap-1">
                <div className="flex items-center gap-2">
                  <div className="text-[12px] sm:text-sm font-semibold text-white">
                    {busDetail?.boarding_city}
                  </div>
                  <div className="text-white h-2.5 sm:h-3.5 w-2.5 sm:w-3.5 mt-0.5">
                    <ArrowRightIcon />
                  </div>
                  <div className="flex flex-col">
                    <div className="text-[12px] sm:text-sm font-semibold text-white">
                      {busDetail?.drop_city}
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <div className="text-sm font-medium text-white">
                    {busDetail?.bus_picktime}
                  </div>
                  <div className="text-white h-3.5 w-3.5 mt-0.5">
                    <ArrowRightIcon />
                  </div>
                  <div className="flex flex-col">
                    <div className="text-[12px] sm:text-sm font-medium text-white">
                      {busDetail?.bus_droptime}
                    </div>
                  </div>
                </div>
                {busDetail?.trip_date && (
                  <div className="text-[12px] sm:text-sm text-white font-medium">
                    {moment(busDetail.trip_date).format("DD MMM YYYY")}
                  </div>
                )}
              </div>
            </div>
            <button className="text-[12px] sm:text-sm font-medium text-white">
              Change
            </button>
          </div>
          <div
            className="w-full h-full overflow-y-auto pb-[100px]"
            onClick={(e) => e.stopPropagation()}
          >
            {ticketActiveStep === 1 ? (
              <Step1 busLayout={busLayout} />
            ) : ticketActiveStep === 2 ? (
              <div id="ticketStep2">
                <Step2 busLayout={busLayout} />
              </div>
            ) : null}
          </div>
        </div>
      </div>

      <PaymentProcessModal
        open={openPaymentProcessingModal}
        setOpen={() => {
          dispatch(setOpenPaymentProcessModal(false));
        }}
      />
    </>
  );
}

export default TicketBooking;
